import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Theme } from 'styles/Themes'
import responsiveSize from 'helper/responsiveSize'

export const ForgotPass = styled(Link)`
  font-family: ${Theme.fontFamily.PRIMARY};

  color: white;

  max-width: 284px;
  height: 16px;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  border: none;
  margin-top: 13px;

  @media only screen and (min-width: 1441px) {
    font-size: 13px;
    margin-top: 15px;
  }
`
